import React, { useCallback, useEffect, useState } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';

import './styles.css'

export default (props) => {

    const message1 = 'Comentário considerado inapropriado ou incompreensível.\n\n';
    const message2 = 'Há uma inconsistência entre os dados e os documentos.\n\n';
    const message3 = 'Há inconsistência entre o endereço cadastrado e o local no mapa.\n\n';
    const messagePF = 'Comentário considerado inapropriado ou incompreensivel.\n\n';
    const [othersMessage, setOthersMessage] = useState('');

    const [isCheckedA, setIsCheckedA] = useState(false);
    const [isCheckedB, setIsCheckedB] = useState(false);
    const [isCheckedC, setIsCheckedC] = useState(false);
    const [isCheckedOthers, setIsCheckedOthers] = useState(false);

    const checked = isCheckedA||isCheckedB||isCheckedC||isCheckedOthers;// checks if theres any checed option
    const [message, setMessage] = useState('');

    const handleCheck = useCallback(() => {
        let mess = 'Você recebeu os seguintes alertas:\n\n';
        
        if(isCheckedA){
            mess += message1; 
        }
       
        if(isCheckedB){
            mess += message2; 
        } 
        
        if(isCheckedC){
            mess += message3; 
        } 
        
        if(isCheckedOthers){
            mess += othersMessage; 
            mess += '\n\n';
        }
        setMessage(mess);
    }, [isCheckedA, isCheckedB, isCheckedC, isCheckedOthers, othersMessage]);
   
    const handleConfirm = () => {
        handleCheck();
        props.setShowProgress(true);
        if(checked) {
            props.alert();
        }
        setIsCheckedA(false);
        setIsCheckedB(false);
        setIsCheckedC(false);
        setIsCheckedOthers(false);
    }

    const handleDecline = () => {
        props.decline(false);//closing modal
        setIsCheckedA(false);//unchecking
        setIsCheckedB(false);
        setIsCheckedC(false);
        setIsCheckedOthers(false);
        props.setMessage('');
    }

    const handleChange = useCallback(async(event) => {
        if(event.target.name === 'checkedA'){
            await setIsCheckedA(!isCheckedA);
        }else if(event.target.name === 'checkedB'){
            await setIsCheckedB(!isCheckedB);
        }else if(event.target.name === 'checkedC'){
            await setIsCheckedC(!isCheckedC);
        }else if(event.target.name === 'checkedOthers'){
            await setIsCheckedOthers(!isCheckedOthers);
        }
    }, [isCheckedA, isCheckedB, isCheckedC, isCheckedOthers]);

    useEffect(() => {
        handleCheck();
        props.setMessage(message);
    }, [props, message, handleCheck]);

    return(
        <div>
            <Dialog
                open={props.showModal} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='sm'
            >
                <DialogContent>
                    <h2 className='modal-pj-title'>{props.title}</h2> <br/><br/>
                    <div>
                        <div className='modal-checkboxes'>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='check1'    
                                        checked={isCheckedA} 
                                        onChange={handleChange} 
                                        name="checkedA" 
                                        color='primary'
                                    />
                                }
                                label={props.PF ? messagePF :message1}
                                disabled={props.showProgress}
                            />

                            { props.PF ? null :
                                <>
                                    <FormControlLabel
                                        control={
                                            <Checkbox 
                                                id='check2'
                                                checked={isCheckedB} 
                                                onChange={handleChange} 
                                                name="checkedB" 
                                                color='primary'
                                            />
                                        }
                                        label={message2}
                                        disabled={props.showProgress}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox 
                                                id='check3'
                                                checked={isCheckedC} 
                                                onChange={handleChange} 
                                                name="checkedC" 
                                                color='primary'
                                            />
                                        }
                                        label={message3}
                                        disabled={props.showProgress}
                                    />
                                </>
                            }
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        id='check4'
                                        checked={isCheckedOthers} 
                                        onChange={handleChange} 
                                        name="checkedOthers" 
                                        color='primary'
                                    />
                                }
                                label="Outros:"
                                disabled={props.showProgress}
                            />
                            <br/> <br/> 
                            {
                                isCheckedOthers ? 
                                    <TextField
                                        id="others-multine"
                                        label="Escreva aqui"
                                        multiline
                                        rows={4}
                                        fullWidth
                                        variant="outlined"
                                        // className='rerse'
                                        disabled={props.showProgress}
                                        onChange={(event)=>{
                                            setOthersMessage(event.target.value);
                                            // props.setMessage(event.target.value)
                                        }}
                                    /> : null 
                            }

                        </div>

                    </div>

                    <br/><br/>
                    <div className='modal-confirm-buttonss'>
                        <button className='modal-confirm-buttons1' onClick={handleDecline} disabled={props.showProgress}>
                            Não, cancelar
                        </button>
                        <button className='modal-confirm-buttons1 btn-cnf' onClick={handleConfirm} disabled={props.showProgress || !checked}>
                            
                            {props.showProgress?
                                <CircularProgress color='primary' size={15} />:
                                <p className='modal-header-button-text'>Sim, confirmar</p>
                            }
                        </button>
                    </div>
                    <br/>
                </DialogContent>
            </Dialog>
        </div>
    )
}